import { CanDeactivateFn } from "@angular/router";
import { Observable } from "rxjs";

/**
 * Contrato que deben implementar los componentes que quieran avisar de cambios
 * sin guardar al intentar abandonar la pantalla (ui-redesign).
 */
export interface CanComponentDeactivate {
	canDeactivate: () => boolean | Promise<boolean> | Observable<boolean>;
}

/**
 * Guard de navegación: delega en el componente. Si éste tiene cambios sin
 * guardar, mostrará su propia confirmación antes de permitir salir.
 */
export const unsavedChangesGuard: CanDeactivateFn<CanComponentDeactivate> = (
	component,
) => {
	return component && typeof component.canDeactivate === "function"
		? component.canDeactivate()
		: true;
};
